export default __webpack_public_path__ + "static/media/office-chair.4d7cdb75.png";